import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import {
  ISelectableEntity,
  ISelectOption,
  ITest,
  ITestType,
} from '../../../data/types';
import { roundValue } from '../../../utils/math';
import { Column } from '../../layout/Column';
import { Avatar } from '../../shared/Avatar';
import { Metric } from '../../shared/Metric';

interface IProps {
  test: ITest;
  metric: ISelectOption;
  testType: ISelectableEntity;
}

export const LatestTest = (props: IProps): React.ReactElement => {
  return (
    <Column
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100%',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <h1 style={{ marginTop: '25px', marginBottom: '25px' }}>Last Test</h1>
        {props.test ? (
          <React.Fragment>
            <div>
              <Avatar
                size='x-large'
                src={props.test.athlete.image}
                imageToken={props.test.athlete.imageToken}
              />
            </div>
            <div style={{ marginTop: '25px' }}>
              <h1 style={{ fontSize: '3rem' }}>{props.test.athlete.name}</h1>
            </div>
            <Metric
              style={{ alignItems: 'center', fontSize: '25rem' }}
              large
              value={roundValue(
                props.test[props.metric.value].value,
                props.test[props.metric.value].roundingPrecision
              )}
              units={
                props.test[
                  !isEmpty(props.metric)
                    ? props.metric.value
                    : (props.testType.entity as ITestType).defaultKey
                ].units
              }
            />
          </React.Fragment>
        ) : null}
      </div>
    </Column>
  );
};
